import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#202020',
    },
    secondary: {
      main: '#212121',
    },
    action: {
      main: '#212121',
    },
  },
});
